import { Component, OnInit } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { PrimeNGConfig } from 'primeng/api';

import { ConstantsModule } from './constants/constants.module';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

	constructor(private primengConfig: PrimeNGConfig, private constantsModule: ConstantsModule, private cookieService: CookieService) {
	}

	ngOnInit(): void {
		this.primengConfig.ripple = true;
	}

	/**
	 * Check if a the user is connected.
	 * @returns
	 */
	public isConnected(): boolean {
		return this.cookieService.get(this.constantsModule.cookieToken) != "";
	}

  /**
   * Check if a the user is an admin.
   * @returns 
   */
	public isAdmin(): boolean {
		// SVI: If role is emtpy, returns TRUE !
		let role = this.cookieService.get(this.constantsModule.cookieRole);
		return role != undefined && role == "A";
	}
}
